import makeBasicTheme from '../makeBasicTheme'
const mainColor = "#eaeaea"
export default makeBasicTheme(mainColor)